import { Routes, Route } from "react-router-dom";
import React, { lazy, Suspense } from 'react';
import Layout from "../components/Layout";

const Home = lazy(() => import("../pages/Home"));
const AboutGroup = lazy(() => import("./AboutGroup"));
const ResourcesGroup = lazy(() => import("./ResourcesGroup"));
const EditGroup = lazy(() => import("./EditGroup"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const NotFound = lazy(() => import("../pages/NotFound"));

const Loading = () => <div>Loading...</div>;

const AppRoutes = () => {
  return (
    <Layout>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about/*" element={<AboutGroup />} />
          <Route path="/resources/*" element={<ResourcesGroup />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/Admin/*" element={<EditGroup />} />
          <Route path="*" element={<NotFound to="/" replace />} />
        </Routes>
      </Suspense>
    </Layout>
  );
};

export default AppRoutes;
